export const validateNoneEmptyHtmlContent = (value: string | null | undefined): boolean => {
  if (!value) return false;
  const doc = new DOMParser().parseFromString(value, 'text/html');
  const textContent = doc.body.textContent || '';
  return textContent.trim().length > 0;
};
